import React from 'react';
import PropTypes from 'prop-types';

const Exclamation = ({ className, fill }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
    <g>
      <g transform="translate(-51 -485)">
        <g id="Notification" transform="translate(29 460)">
          <path fill={fill} d="M35.5 47.5h3v-3h-3v3zm0-6h3v-9h-3v9zm-9.1-12.1C29.3 26.5 32.9 25 37 25s7.7 1.5 10.6 4.4C50.5 32.3 52 35.9 52 40s-1.5 7.7-4.4 10.6C44.7 53.5 41.1 55 37 55s-7.7-1.5-10.6-4.4C23.5 47.7 22 44.1 22 40s1.5-7.7 4.4-10.6z" />
        </g>
      </g>
    </g>
  </svg>
);

Exclamation.propTypes = {
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * String hex code for SVG fill attribute.
   */
  fill: PropTypes.string,
};

Exclamation.defaultProps = {
  className: '',
  fill: '',
};

export default Exclamation;
